import { Injectable } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BaseModalController } from '@app/components/modals/base/base.modal-controller';
import { EditNotificationSetModalComponent } from '@modules/notification-management/modals/edit-notification-set-modal/edit-notification-set-modal.component';
import { IBaseNotificationPayload } from '@modules/notification-management/interfaces/notifications.interface';

@Injectable({
	providedIn: 'root', // Makes the service available globally
})
export class EditNotificationSetModalController extends BaseModalController {
	constructor(modal: BsModalService) {
		super(modal);
	}

	public init(config: IBaseNotificationPayload): void {
		this.launch(EditNotificationSetModalComponent, { class: 'modal-lg' });
		(this._componentInstance as EditNotificationSetModalComponent).setup(config);
	}
}
